module.exports = __webpack_public_path__ + "static/media/shared-debt_icon.58c3d299.svg";